// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Zo0u","col":"styles_col__ux8QK"};